package games.polyclub.frontend.store.shared

import games.polyclub.service.config.api.SecretString
import kotlinx.serialization.Serializable

@Serializable
data class LoginRequest(
    val user: SecretString,
    val password: SecretString,
    val captcha: String,
    val remember: Boolean,
)
